import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import DebounceLink from 'apollo-link-debounce';

import Config from 'config';

export default props => <ApolloProvider client={Apollo}>{props.children}</ApolloProvider>;

// helpers
const customFetch = (uri, options) => {
  // Support access_token being passed as a query.
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('access_token');

  let endpoint = `${Config.api.host}/graphql`;
  if (accessToken) {
    endpoint += `?access_token=${accessToken}`;
  }

  // note to future: this function needs to be defined BEFORE the ApolloClient
  //  is defined, or else this customFetch function will never execute; ordering matters
  return fetch(endpoint, {
    ...options,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.CSRF_TOKEN,
    },
  }).then(response => {
    const csrfToken = response.headers.get('X-CSRF-Token');
    if (csrfToken) {
      window.CSRF_TOKEN = csrfToken;
    }
    return Promise.resolve(response);
  });
};

const Apollo = new ApolloClient({
  link: ApolloLink.from([
    (new DebounceLink(0)),
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          // eslint-disable-next-line no-console
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        });
      }
      if (networkError) {
        // eslint-disable-next-line no-console
        console.log(`[Network error]: ${networkError}`);
      }
    }),
    createHttpLink({ fetch: customFetch }),
  ]),
  cache: new InMemoryCache(),
});
